import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {UserProfileService} from '@shared/services/api/user-profile.service';

const REDIRECT_PATH_BY_ALIAS: Map<string, string> = new Map([
  ['preferences', 'user-preferences'],
]);

export const MyRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _: RouterStateSnapshot): boolean | UrlTree => {
  const router = inject(Router);
  const userProfileService = inject(UserProfileService);
  const user = userProfileService.getLoggedInUser();
  if (user) {
    const urlAlias = route.url.pop();
    const pathAlias = urlAlias.path;
    const destinationPath = REDIRECT_PATH_BY_ALIAS.get(pathAlias) ?? pathAlias;
    return router.createUrlTree(['/account', user.userId, destinationPath]);
  }
  return false;
}
